// File: client/src/variants/royale/rulebook.js
// Canonical rulebook for Chess Royale.

const rulebook = {
  overview:
    'Battle-royale chess. The playable board shrinks over time — the outer ring collapses every 5 full turns, and any piece caught outside the arena is destroyed. Keep your king safe and push your opponent’s pieces to the edge.',
  objective:
    'Be the last king standing. Eliminate the opponent’s king — by checkmate, or by trapping it in the collapsing ring — while keeping your own king inside the arena.',
  setup:
    'Standard starting position on a full 8×8 board. White moves first.',
  turnFlow: [
    'Make one normal legal chess move.',
    'You cannot move a piece onto a tile that has already collapsed.',
    'Every 5 full turns, the outer ring collapses and the arena shrinks.',
    'Any piece (including a king) standing on a collapsing tile is destroyed.',
  ],
  mechanics: [
    {
      title: 'The shrinking arena',
      body: 'The playable area is a centred square that collapses in stages: 8×8 → 6×6 → 4×4 → 2×2. Each stage happens after another 5 full turns (10 half-moves).',
    },
    {
      title: 'Destruction',
      body: 'When the ring collapses, every piece outside the new arena is removed from the game immediately — no capture, no points. Plan escapes early.',
    },
    {
      title: 'The 2×2 endgame',
      body: 'Once the arena reaches 2×2 it stops shrinking. Games are decided quickly from there.',
    },
  ],
  winConditions: [
    'Win by checkmating the opponent’s king.',
    'Win if the opponent’s king is destroyed by the collapsing ring (last king alive).',
    'Win if the opponent resigns or runs out of time.',
    'If both kings are somehow destroyed on the same collapse, the game is a draw.',
    'Stalemate is a draw, as in classic chess.',
  ],
  tips: [
    'CRITICAL: your king starts on the back rank, which is the FIRST ring to collapse. You have 5 turns to walk it inward — do not leave it on the edge!',
    'Move your king toward the centre early — the edges disappear first.',
    'Use the collapse as a weapon: force enemy pieces to the rim before a shrink.',
    'Watch the “ring collapses in N moves” timer at the top of the screen.',
  ],
  knownInteractions: [
    'Rule decision: the arena is a CENTRED square (8→6→4→2 uses index ranges [0,7]→[1,6]→[2,5]→[3,4]), so shrinking is symmetric on all sides.',
    'Rule decision: a shrink occurs every 5 FULL turns (10 half-moves), counted from the game start.',
    'Rule decision: you may not move onto an already-collapsed tile; such moves are hidden from the legal-move list.',
    'Rule decision: king elimination by collapse is checked immediately after the ring falls, and takes precedence over checkmate detection that turn.',
    'EDGE CASE (by design): kings start on the back rank, which is destroyed by the first (6×6) shrink. If BOTH players leave their king on the rim, the first shrink removes both kings and the game is a DRAW. This is intentional — relocating the king toward the centre is the core strategic demand of Chess Royale, and the on-screen timer telegraphs every collapse.',
    'AI: the computer plays standard chess and is not shrink-aware; it will not deliberately flee the collapsing ring, so on hard settings the human can often win simply by surviving the ring. Documented limitation — a future enhancement could make the AI arena-aware via the variant AI hook.',
  ],
};

export default rulebook;
